import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { VideoEmbed, PdfEmbed } from "@/components/MediaEmbed";
import { ArrowLeft, Video, FileText, ExternalLink } from "lucide-react";

export default function MaterialDetail() {
  const { id } = useParams();
  const { data: m, isLoading, isError } = useQuery({
    queryKey: ["material", id],
    queryFn: () => api.get(`/materials/${id}`).then((r) => r.data),
  });

  if (isLoading) return <p className="text-muted-foreground">Memuat…</p>;
  if (isError || !m)
    return (
      <div className="space-y-4">
        <p className="text-muted-foreground">Materi tidak ditemukan.</p>
        <Button asChild variant="outline"><Link to="/materials"><ArrowLeft className="h-4 w-4 mr-1" /> Kembali</Link></Button>
      </div>
    );

  return (
    <article className="max-w-3xl mx-auto space-y-6 fade-in-up">
      <Button asChild variant="ghost" size="sm" className="gap-1 -ml-2" data-testid="back-to-materials">
        <Link to="/materials"><ArrowLeft className="h-4 w-4" /> Semua Materi</Link>
      </Button>

      <div>
        <div className="text-xs font-data text-muted-foreground mb-1">Bab {m.order}</div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">{m.title}</h1>
      </div>

      {m.image_url && <img src={m.image_url} alt={m.title} className="rounded-md w-full max-h-80 object-cover" />}

      <p className="text-base leading-relaxed whitespace-pre-wrap text-foreground/90">{m.body}</p>

      {m.video_url && (
        <section className="space-y-2">
          <h2 className="font-heading font-bold text-lg flex items-center gap-2"><Video className="h-5 w-5 text-primary" /> Video Pembelajaran</h2>
          <VideoEmbed url={m.video_url} />
        </section>
      )}

      {m.pdf_url && (
        <section className="space-y-2">
          <div className="flex items-center justify-between flex-wrap gap-2">
            <h2 className="font-heading font-bold text-lg flex items-center gap-2"><FileText className="h-5 w-5 text-primary" /> Dokumen PDF</h2>
            <Button asChild variant="outline" size="sm" data-testid="open-pdf-newtab">
              <a href={m.pdf_url} target="_blank" rel="noreferrer">Buka di tab baru <ExternalLink className="h-3.5 w-3.5 ml-1" /></a>
            </Button>
          </div>
          <PdfEmbed url={m.pdf_url} />
        </section>
      )}
    </article>
  );
}
